import { RootState } from "store/store"
import { EstadoRequisicao } from "store/types";


export class AutorizacaoSelector {
  static readonly isOcioso = (it: RootState) => it.autorizacao.estado === EstadoRequisicao.OCIOSO;

  static readonly autorizacao = (it: RootState) => it.autorizacao.autorizacao;
}
